export const footerReducer = {
  socialMedia: [
    {
      key: "facebook",
      icon: "facebook",
      url: "https://web.facebook.com/autopia.cl/",
    },
    {
      key: "instagram",
      icon: "instagram",
      url: "https://www.instagram.com/autopia.cl/?igshid=1f3dg478yieki",
    },
    {
      key: "youtube",
      icon: "youtube",
      url: "https://www.youtube.com/AutopiaCL",
    },
    {
      key: "linkedin",
      icon: "linkedin",
      url: "https://www.linkedin.com/company/autopia-chile/",
    },
  ],
  sections: [
    {
      key: "conoce-autopia",
      title: "CONOCE AUTOPIA",
      items: [
        {
          key: "quienes-somos",
          title: "¿Quiénes somos?",
          url: "",
        },
        {
          key: "derco-usados",
          title: "Derco Usados",
          url: "",
        },
        {
          key: "vendenos-tu-auto",
          title: "Véndenos tu auto",
          url: "",
        },
        {
          key: "sucursales",
          title: "Sucursales",
          url: "",
        },
        {
          key: "blog-autopia",
          title: "Blog Autopia",
          url: "",
        },
      ],
    },
    {
      key: "informacion",
      title: "INFORMACIÓN",
      items: [
        {
          key: "terminos-y-condiciones",
          title: "Términos y condiciones",
          url: "",
        },
        {
          key: "politicas-de-privacidad",
          title: "Políticas de privacidad",
          url: "",
        },
        {
          key: "bases-legales",
          title: "Bases legales",
          url: "",
        },
        {
          key: "preguntas-frecuentes",
          title: "Preguntas frecuentes",
          url: "",
        },
        {
          key: "trabaja-con-nosotros",
          title: "Trabaja con Nosotros",
          url: "",
        },
      ],
    },
    {
      key: "servicios-autopia",
      title: "SERVICIOS AUTOPIA",
      items: [
        {
          key: "garantia-autopia",
          title: "Garantía Autopia",
          url: "",
        },
        {
          key: "financiamiento",
          title: "Financiamiento",
          url: "",
        },
      ],
    },
    {
      key: "siguenos",
      title: "SÍGUENOS",
      items: [],
    },
  ],
  logos: [
    {
      key: "derco",
      icon: "derco",
      url: "",
    },
    {
      key: "derco-center",
      icon: "derco-center",
      url: "",
    },
    {
      key: "derco-maq",
      icon: "derco-maq",
      url: "",
    },
    {
      key: "autopia",
      icon: "autopia",
      url: "",
    },
    {
      key: "autoplanet",
      icon: "autoplanet",
      url: "",
    },
    {
      key: "agroplanet",
      icon: "agroplanet",
      url: "",
    },
  ],
  copyright: "© 2022 Dero SpA. Todos los derechos reservados"
};
